const pathMap = {
    'troubleshooting/what-does-the-missing-prices-warning-mean': 'troubleshooting/missing-prices',
    'troubleshooting/what-does-the-missing-pta-warning-mean': 'troubleshooting/missing-pta',
    'troubleshooting/what-does-the-journal-whitelist-alert-mean': 'troubleshooting/journal-whitelist',
    'troubleshooting/why-dont-i-see-a-certain-title-in-my-dashboard': 'troubleshooting/missing-title',
    'how-to-guides/upload-counter-usage-data': 'how-to-guides/upload-counter-usage-data',
    'how-to-guides/upload-title-prices': 'how-to-guides/upload-title-prices',
    'how-to-guides/set-currency': 'how-to-guides/set-currency',
    'how-to-guides/set-big-deal-costs': 'how-to-guides/set-big-deal-costs',
    'how-to-guides/upload-pta-data': 'how-to-guides/upload-pta-data',
    'how-to-guides/upload-journal-filter': 'how-to-guides/upload-journal-filter',
    'how-to-guides/excluded-titles-report': 'how-to-guides/excluded-titles-report',
    'how-to-guides/apc-report': 'how-to-guides/apc-report',
    'how-to-guides/select-journals': 'how-to-guides/select-journals',
    'reference/subscription-costs': 'reference/subscription-costs',
}

export function docsUrl(locale, path) {
    if (locale !== 'ja') {
        return path ? `https://docs.unsub.org/${path}` : 'https://docs.unsub.org'
    }
    if (!path) {
        return 'https://docs.unsub-jpn.ijapan.info/'
    }
    const jaPath = pathMap[path] || path
    return `https://docs.unsub-jpn.ijapan.info/#/${jaPath}`
}
